import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useHistory } from "react-router-dom";
import Spinner from "web/components/Spinner";
import { storeAdminDetails, logoutAdmin} from 'redux/actions/admin';
import { inviteNewCustomerApi } from 'redux/actions/adminPtPlus/index';
import AlertModal from 'web/components/AlertModal';
import CloseIcon from "web/assets/images/CloseIcon.png";
import MultipleEmailInput from "web/components/form-elements/MultipleEmailInput";

function InviteNewCustomerModal(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    const [alertType, setAlertType] = useState('')

    const INITIAL_VALUES = {
        email: ''
    };
    const VALIDATION_SCHEMA = Yup.object().shape({
        email: Yup.string().trim().email().required('Email is required.')
    });

    const inviteNewCustFunction = async (values) => {
        let response = ''
        let emailList = values.email?.map(val => {
            return (
                { email: val }
            )
        })
        let data = {
            emails: emailList
        }
        const token = localStorage.getItem('token')
        response = await dispatch(inviteNewCustomerApi(data, token))
        if (response.success) {
            setAlertModalContent('Invitation sent to user’s email.')
            setAlertType('adminNewCustomerInvite')
            setAlertModal(!alertModal)
        } else {
            if (response?.data?.error?.message.includes('email is declined')) {                
                setAlertModalContent(`User's email is declined or already registered so invitation cannot be send.`)
                setAlertModal(!alertModal)
            } else if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }
    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }
    const isValidFieldsFun = (values) => {
        let emailLists = values.email
        if (emailLists?.length > 0) return true
        else return false
    }

    return (
        <>
            {loaderVisible && <Spinner />}
            <div>
                <div className="modal-header-style">
                    <h6>Invite New Customer</h6>
                    <img src={CloseIcon} alt="close-icon" onClick={() => pageProps.toggle()} />
                </div>

                <div className="modal-content-style">
                    <Formik
                        initialValues={INITIAL_VALUES}
                        validationSchema={VALIDATION_SCHEMA}
                        onSubmit={(values) => {
                        }}>
                        {(props) => {
                            return (
                                <>
                                    <Form>
                                        <div>
                                            <MultipleEmailInput
                                                name="email"
                                                placeholder='Emails'
                                            />
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <button className={isValidFieldsFun(props.values) ? 'invite-button' : 'invite-button-disabled'}
                                                    disabled={!isValidFieldsFun(props.values)}
                                                    onClick={() => inviteNewCustFunction(props.values)}>Invite</button>
                                            </div>
                                        </div>
                                    </Form>
                                </>
                            );
                        }}
                    </Formik>
                </div>

                {/* <div className="modal-content-style">
                    <input placeholder="Email" className="invite-email-style" value={emailInputState}
                        onChange={(e) => setEmailInputState(e.target.value)} />
                    <button className={isValidFields ? 'invite-button' : 'invite-button-disabled'}
                        onClick={inviteNewCustFunction}>Invite</button>
                </div> */}
            </div>
            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                content={alertModalContent}
                alertType={alertType}
                callBackAlert={() => {
                    if (alertType === 'adminNewCustomerInvite') {
                        pageProps.toggle()
                    }
                }}
            />
        </>
    );
}

export default InviteNewCustomerModal;
